import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchUsers(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/users/users', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_USERS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* removeUser(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.delete, '/users/remove', {
    query: {
      id: payload.id,
    }
  });
  yield put({
    type: 'FETCH_USERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* createUser(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/users/create', {
    body: {
      ...payload.data,
    }
  });
  yield put({
    type: 'FETCH_USERS',
  });

  yield put({
    type: 'TOGGLE_MODAL',
    payload: {
      active: false,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_USERS', fetchUsers),
    takeLatest('REMOVE_USER', removeUser),
    takeLatest('CREATE_USER', createUser),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Users/Users.sagas.js